import React, { useMemo } from "react";
import { Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { RouteMap } from "./routeMap";

// Raw "lat,lng" strings (e.g. mobileresponse.cords: start / finish) -> google.maps.LatLngLiteral,
// dropping anything that doesn't parse so a bad string never reaches the map.
const parseCoords = (raw) =>
  (raw || [])
    .map((c) => {
      const [lat, lng] = String(c).split(",").map(Number);
      return Number.isNaN(lat) || Number.isNaN(lng) ? null : { lat, lng };
    })
    .filter(Boolean);

// Modal wrapper around RouteMap for callers whose points come as raw "lat,lng" strings
// (originally built for the Completed Mobile Services "See Route" link, reused by the
// duty detail Activity tab). `titles` is optional, same length/order as `coords`, for
// callers that have per-point labels (e.g. "Clock In - 08:03") to show in the popover.
// `showLabels` (off by default) letters the pins A, B, C, ... - see RouteMap for when
// that's appropriate. `geofence` is passed straight through to RouteMap - see there for
// its shape. Callers that already have parsed {lat,lng} points and want the map inline
// rather than in a popup should render <RouteMap/> directly instead.
export const RouteMapModal = ({ visible, onClose, coords, titles, showLabels, geofence }) => {
  const points = useMemo(() => parseCoords(coords), [coords]);

  return (
    <Modal open={visible} footer={null} closable={false} width={680} destroyOnClose>
      <div className="modal-header-title">
        <span>Route</span>
        <span onClick={onClose}><FontAwesomeIcon className="close" icon={faClose} /></span>
      </div>

      <div className="modal-body">
        <RouteMap points={points} titles={titles} showLabels={showLabels} geofence={geofence} />
      </div>
    </Modal>
  );
};
